var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobile = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.75C4.5 2.05964 5.05964 1.5 5.75 1.5H18.25C18.9404 1.5 19.5 2.05964 19.5 2.75V21.25C19.5 21.9404 18.9404 22.5 18.25 22.5H5.75C5.05964 22.5 4.5 21.9404 4.5 21.25V2.75ZM5.75 0C4.23122 0 3 1.23122 3 2.75V21.25C3 22.7688 4.23122 24 5.75 24H18.25C19.7688 24 21 22.7688 21 21.25V2.75C21 1.23122 19.7688 0 18.25 0H5.75ZM11.9901 18C11.1671 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1671 21 11.9901 21H12.0099C12.8329 21 13.5 20.3284 13.5 19.5C13.5 18.6716 12.8329 18 12.0099 18H11.9901Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile.9f4965b7c8dbee4ad2c80165140c49c2.svg";